import { db } from "./firebase"
import { table } from "./firebase"
import { watchData } from "./firebase"

const store = {
  state: {
    statusServer: [{
      key: "status",
      messages: "online"
    },
    {
      key: "warning",
      messages: "-"
    }],
  },
  mutations: {
    setStatusServer(state, data) {
      state.statusServer = data;
    },
  },
  actions: {
    watchServer({ commit, state }) {
      // const starCountRef = table(db, 'server');

      watchData(table, (snapshot) => {
        let msg = []
        // const data = snapshot.val();
        snapshot.forEach(function (childSnapshot) {
          let temp = { key: '', messages: [] }
          temp.key = childSnapshot.key
          temp.messages = childSnapshot.val()
          msg.push(temp)
        });
        // console.log(msg)
        if (msg.length > 0) {
          let master = ['online', 'offline', 'retest']
          if (master.includes(msg[0].messages)) {
            // console.log("true ==>")
          } else {
            msg = state.statusServer
          }
        } else {
          msg = state.statusServer
        }
        commit("setStatusServer", msg)
        localStorage.setItem("setStatusServer", msg[0].messages)
      }, function (errorObject) {
        // console.log("The read failed: " + errorObject.code);
      });
    }
  },
  getters: {
    statusServer(state) {
      return state.statusServer;
    },
  }
}

export default store;